import styled from 'styled-components';
import { variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ComponentVariants } from './type';

export const PageHeaderTitleWrapper = styled.div<{
  variant?: ComponentVariants;
}>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'PageHeaderTitle', 'variant')
    )};
`;

PageHeaderTitleWrapper.defaultProps = {
  variant: 'regular',
};
